(() => {
  const STORAGE_KEY = 'jd-vat-display';
  const VALID_VIEWS = new Set(['inc', 'ex']);

  function getView() {
    const current = document.documentElement.dataset.vatDisplay;
    return VALID_VIEWS.has(current) ? current : 'inc';
  }

  function syncControls(root = document) {
    const view = getView();
    root.querySelectorAll('[data-vat-option]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.vatOption === view));
    });
  }

  function setView(view, save = true) {
    if (!VALID_VIEWS.has(view)) return;
    document.documentElement.dataset.vatDisplay = view;
    syncControls();

    if (save) {
      try {
        localStorage.setItem(STORAGE_KEY, view);
      } catch (error) {
        // The display still works when storage is unavailable.
      }
    }

    document.dispatchEvent(new CustomEvent('vat:display:change', { detail: { view } }));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vat-option]');
    if (!button) return;
    setView(button.dataset.vatOption);
  });

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('[data-vat-option]')) syncControls(node.parentElement || document);
        if (node.querySelector?.('[data-vat-option]')) syncControls(node);
      });
    });
  });

  syncControls();
  observer.observe(document.body, { childList: true, subtree: true });
})();

